import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../Spinner/Spinner';

const FullPageLoader = memo(props => {
  const { title, loading } = props;

  return loading ? (
    <div
      data-test="full-page-loader"
      className="h-screen w-screen fixed top-0 left-0 backdrop-blur-sm  z-50 flex justify-center items-center transition-all duration-1000 ease-in-out"
      style={{ zIndex: 1001 }}
    >
      <div className="w-1/6 h-1/6  bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out flex items-center justify-center">
        <p className="pr-2">{title}...</p>
        <div>
          <Spinner loading={loading} />
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  ) : null;
});

FullPageLoader.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
};

export default FullPageLoader;
